import { Col, Divider, Row } from 'antd';
import { FacebookIcon } from '../../../Assets/icons/facebook_icon';
import { InstagramIcon } from '../../../Assets/icons/instagram_icon';
import { LinkedinIcon } from '../../../Assets/icons/linkedin_icon';
import { YoutubeIcon } from '../../../Assets/icons/youtube_icon';
import './index.scss';

import gamaLogo from '../../../Assets/images/gamamobility-logo-hz-white.svg';
import gamaPa from '../../../Assets/images/gama-patrocinador.png';

export const LandingFooterComponent = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="landing-footer" data-render="LandingFooterComponent">
      <div
        style={{
          padding: '40px 30px 20px 30px',
        }}
      >
        <Row justify="center">
          <Col xs={24} md={12} lg={5} className="footerMenuItemHome">
            <div>
              <img src={gamaLogo} alt="Gama Mobility" style={{ width: '180px', height: 'auto' }} />
            </div>

            <div className="footerSocialMedia">
              <a className="media" href="https://www.facebook.com/gamaleasing2013">
                <FacebookIcon />
              </a>
              <a className="media" href="https://www.instagram.com/gamamobility/">
                <InstagramIcon />
              </a>
              <a className="media" href="https://www.linkedin.com/company/gamaleasing">
                <LinkedinIcon />
              </a>
              <a className="media" href="https://www.youtube.com/@gamamobility">
                <YoutubeIcon />
              </a>
            </div>

            <div
              style={{
                marginTop: '40px',
              }}
            >
              <img
                src={gamaPa}
                alt="gamaLogo"
                style={{
                  width: '106px',
                  height: '58px',
                }}
              />
            </div>
          </Col>

          <Col xs={24} md={12} lg={5} className="footerMenuItemHome">
            <div>
              <strong>Empresa</strong>
            </div>

            <div className="footSubmenuGroupItem">
              <a href="https://gamamobility.cl/nosotros/">Nosotros</a>
              <a href="https://gamamobility.cl/inversionistas/">Inversionistas</a>
              <a href="https://gamamobility.trabajando.cl/">Trabaja con nosotros</a>
              <a href="https://gamamobility.cl/blog/">Blog</a>
              <a href="https://am-external.gamamobility.cl/">Portal de Proveedores</a>
            </div>
          </Col>

          <Col xs={24} md={12} lg={5} className="footerMenuItemHome">
            <div>
              <strong>Servicios</strong>
            </div>
            <div className="footSubmenuGroupItem">
              <a href="https://gamamobility.cl/">Rent a Car</a>
              <a href="https://gamamobility.cl/leasing-operativo/">Leasing Operativo</a>
              <a href="https://gamamobility.cl/listado-de-sucursales/">Sucursales Rent a Car</a>
            </div>
          </Col>

          <Col xs={24} md={12} lg={5} className="footerMenuItemHome">
            <div>
              <strong>Ayuda y Soporte</strong>
            </div>
            <div className="footSubmenuGroupItem">
              <a href="https://gamamobility.cl/portal-de-siniestros/">Portal de Siniestros</a>
              <a href="https://www.webpay.cl/company/33000">Paga tu Leasing</a>
              <a href="https://pagos.gamamobility.cl/">Paga tu Renting</a>
              <a href="https://gamamobility.cl/preguntas-frecuentes/">Preguntas Frecuentes</a>
            </div>
          </Col>
        </Row>
        <Row justify="center">
          <Divider style={{ backgroundColor: '#262626' }}></Divider>
        </Row>
        <Row justify="center">
          <Col xs={24} lg={12} className="footerBottomMenuLeft">
            <a href="https://gamamobility.cl/legales">Políticas de Privacidad</a>
            <span>|</span>
            <a href="https://gamamobility.cl/terminos-y-condiciones/">Términos y Condiciones</a>
            <span>|</span>
            <a href="https://gamamobility.cl/canal-de-denuncias/">Canal de Denuncias</a>
          </Col>
          <Col xs={24} lg={12} className="footerBottomMenuRight">
            © {year} GAMA MOBILITY. Todos los derechos reservados.
          </Col>
        </Row>
      </div>
    </footer>
  );
};
